export default __webpack_public_path__ + "static/media/SNUG-DB.097a6b37.png";